import { RouteUtils } from "utilities/route-utils";
import axios from "axios";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------
export interface PdfBasePathParams {}
export interface PdfQueryParams {
    url: string;
    name: string;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const baseEndpoint = "pdfs/generate";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Service
// -----------------------------------------------------------------------------------------

export const PdfService = {
    /**
     * WIP: Generates a PDF
     * Controller not to be committed until after review
     */
    get: async (queryParams) => {
        const url = RouteUtils.getUrl(baseEndpoint, {}, queryParams);
        return await axios({
            url,
            method: "GET",
            responseType: "blob",
        }).then((response) => {
            // Could probably be better, or maybe added in as
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${queryParams.name}.pdf`);
            document.body.appendChild(link);
            link.click();
        });
    },
};

// #endregion Service
